var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"top-header"},[_c('div',{staticClass:"container no-padding"},[_c('span',{staticClass:"adr u-c"},[_c('div',{staticClass:"fa fa-map-marker-alt"}),_vm._v(" "+_vm._s(_vm.tr.address))])])])}
var staticRenderFns = []

export { render, staticRenderFns }